<div class="row" *ngIf="actionSetting$ | async as actionSettings">
   <div class="k-form-field">
      <label class="sam-margin-left-medium sam-center-left" fxFlex="40%" for="{{ actionId }}-skill">
         {{ 'user_actions.types.make_call.settings.skill' | translate }}
      </label>
      <kendo-dropdownlist
         fxFlex="60%"
         id="{{ actionId }}-skill"
         [data]="selectableSkills$ | async"
         [textField]="'name'"
         [valueField]="'id'"
         [loading]="isLoadingSelectableSkills$ | async"
         [value]="selectedSkill$ | async"
         (valueChange)="skillChanged(actionSettings, $event)"
      >
         <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
            <fa-icon [icon]="(dataItem.type | toQueueType).icon" [fixedWidth]="true" *ngIf="dataItem"></fa-icon>
            {{ dataItem?.name }}
         </ng-template>
      </kendo-dropdownlist>
   </div>
</div>
